import * as React from 'react';
import UseTimeCountdown from '../../../Hooks/UseTimeCountdown';
import { discoverNFTData, } from '../../../Shared/FackeDataFactory';
import { Swiper, SwiperSlide } from 'swiper/react';
import { AnimatePresence, motion } from "framer-motion"

import "swiper/css";
import "swiper/css/pagination";
import { Pagination, } from "swiper";
import { hotBidsNFTData } from '../../../Shared/ExploreDataFactory';
import { useNavigate, } from 'react-router-dom';
import useClickOutside from '../../../Hooks/useClickOutside';
import { useState } from 'react';
export interface IAppProps {
}

export function HotAndExpoloreSection(props: IAppProps) {

    // For the Hot Bids-----------------------------------*
    const [hotBidsData, setHotBidsData] = React.useState(hotBidsNFTData)
    let navigate = useNavigate();
    const handleNFTOnClick = (id: number) => {
        navigate(`/exploreNftDetails/${id}/bids`)
    }
    const handleLoveOnClick = (index: number) => {
        const previousData = [...hotBidsData]
        const findMatchData = previousData[index]

        if (findMatchData.nftPostData.isMyloves) {
            findMatchData!.nftPostData.loves = findMatchData.nftPostData.loves - 1
            findMatchData.nftPostData.isMyloves = false;
            setHotBidsData(previousData)
        } else {
            findMatchData!.nftPostData.loves = findMatchData.nftPostData.loves + 1
            findMatchData.nftPostData.isMyloves = true;
            setHotBidsData(previousData)
        }
    }

    //handle Hot bids nft three dot modal
    const [threeDotText, setThreeDotText] = useState('')
    const threeDotModalRefs = React.useRef(new Array())
    const [clickedThreeDotIndex, setClickedThreeDotIndex] = useState(-1)
    const [isThreeDotModalOpen, setIsThreeDotModalOpen] = React.useState(() => [].map((x) => false));

    useClickOutside({ current: threeDotModalRefs.current[clickedThreeDotIndex] }, () => {
        const newVisibilities = [...isThreeDotModalOpen];
        newVisibilities[clickedThreeDotIndex] = false;
        setIsThreeDotModalOpen(newVisibilities);
    })
    const hanldeThreeDotBtn = (index: any) => {
        const newVisibilities = [...isThreeDotModalOpen];
        newVisibilities[index] = !newVisibilities[index];

        setIsThreeDotModalOpen(newVisibilities);
        setClickedThreeDotIndex(index)
    };

    React.useEffect(() => {
        const arrayData = threeDotModalRefs.current.map((data, index) => `${index}`)
        setIsThreeDotModalOpen(() => arrayData.map((x) => false));
    }, [])






    return (
        <div className="">

            {/* ----------------------------Hot Bids---------------------------- */}
            <div className="mt-14 swiper_pagination_controller_box relative ">
                <div className="flex justify-between items-center">
                    <div className="relative inline-block">
                        <h1 className="xs:text-2xl xl:text-3xl mr-3 font-extrabold text-cusBlack dark:text-white">Hot Bids</h1>
                        <div className="bottom-1 absolute -right-4">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={12} height={12} viewBox="0 0 12 12">
                                <defs>
                                    <linearGradient id="linear-gradient" x1="0.875" y1="0.174" x2="0.139" y2="0.84" gradientUnits="objectBoundingBox">
                                        <stop offset={0} stopColor="#00dbff" />
                                        <stop offset="0.529" stopColor="#e315e8" />
                                        <stop offset={1} stopColor="#ffd817" />
                                    </linearGradient>
                                </defs>
                                <circle id="Ellipse_1" data-name="Ellipse 1" cx={6} cy={6} r={6} fill="url(#linear-gradient)" />
                            </svg>
                        </div>
                    </div>
                </div>

                <div className="px-2 xxsm:px-8 xsm:px-0">
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={10}
                        pagination={{
                            clickable: true,
                        }}
                        breakpoints={{
                            0: { slidesPerView: 1, spaceBetween: 40, },
                            350: { slidesPerView: 1, spaceBetween: 95, },
                            440: { slidesPerView: 2, spaceBetween: 10, },
                            640: { slidesPerView: 2, spaceBetween: 40, },
                            769: { slidesPerView: 3, spaceBetween: 15, },
                            1024: { slidesPerView: 4, spaceBetween: 15, },
                            1280: { slidesPerView: 5, spaceBetween: 15, },
                            1536: { slidesPerView: 6, spaceBetween: 15, },
                        }}
                        effect="fade"
                        modules={[Pagination]}
                        className="mySwiper mt-3 overflow-visible "
                    >
                        {hotBidsData.slice(0, 10).map((data, index) =>
                            <SwiperSlide key={data.id} style={{ overflow: 'visible' }}>
                                <div className="p-3 rounded-lg mt-5 h-full overflow-visible transition-all
                            bg-[#ffffff] dark:bg-[#292757] dark:hover:bg-[#CA12F6] hover:bg-[#CA12F6] border border-[#D8D8D8] dark:border-[#292757] group
                            ">
                                    <div className="flex justify-between items-center">
                                        <div className="flex justify-start items-center ml-3">
                                            {data.profiles.map((prfl, index) =>
                                                <img key={index} src={prfl} alt="" className="w-6 h-6 -ml-2" />
                                            )}
                                        </div>
                                        <div className="flex justify-end items-center">

                                            <div
                                                className="flex cursor-pointer justify-between py-1 px-2 items-center rounded-full
                                            bg-[#F5F5F5] dark:bg-[#140D36] group-hover:bg-[#e589fb]"
                                                onClick={() => handleLoveOnClick(index)}>
                                                <p className="text-gray-800 dark:text-cusBlueWhite text-xs mr-0.5 
                                            dark:group-hover:text-white group-hover:text-white">{data.nftPostData.loves}</p>

                                                {data.nftPostData.isMyloves &&
                                                    <motion.svg
                                                        initial={{ scale: 0.5 }}
                                                        animate={{ scale: 1 }}
                                                        xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 group-hover:stroke-[#CA12F6]" fill="#CA12F6" viewBox="0 0 24 24" stroke="#CA12F6" strokeWidth={2}>
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                                                    </motion.svg>
                                                }

                                                {!data.nftPostData.isMyloves &&
                                                    <motion.svg
                                                        initial={{ scale: 0.5 }}
                                                        animate={{ scale: 1 }}
                                                        xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 group-hover:stroke-[#CA12F6]" fill="none" viewBox="0 0 24 24" stroke="#6f6dab" strokeWidth={2}>
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                                                    </motion.svg>
                                                }
                                            </div>


                                            <div className="relative" ref={(el) => threeDotModalRefs.current[index] = el}>
                                                <button className="ml-3 three_dot_btn" onClick={() => hanldeThreeDotBtn(index)}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width={5} height={18} viewBox="0 0 5 21">
                                                        <g id="Group_1481" data-name="Group 1481" transform="translate(0)">
                                                            <circle className="group-hover:fill-white" id="Ellipse_374" data-name="Ellipse 374" cx="2.5" cy="2.5" r="2.5" transform="translate(0)" fill="#6f6dab" />
                                                            <circle className="group-hover:fill-white" id="Ellipse_375" data-name="Ellipse 375" cx="2.5" cy="2.5" r="2.5" transform="translate(0 8)" fill="#6f6dab" />
                                                            <circle className="group-hover:fill-white" id="Ellipse_376" data-name="Ellipse 376" cx="2.5" cy="2.5" r="2.5" transform="translate(0 16)" fill="#6f6dab" />
                                                        </g>
                                                    </svg>
                                                </button>
                                                <div className="absolute right-0 top-6 z-50">
                                                    <AnimatePresence>
                                                        {isThreeDotModalOpen[index] &&
                                                            <motion.div
                                                                initial={{ height: 0, width: 0 }}
                                                                animate={{ height: "auto", width: '' }}
                                                                exit={{ height: 0, width: 0 }}
                                                                transition={{ duration: 0.3 }}
                                                                className="overflow-hidden w-full max-w-[192px] bg-white border-2 dark:border-[#ffffff10] shadow-2xl shadow-[#00000050] dark:bg-[#363375] rounded"
                                                            >
                                                                {["Place floor bid", "New Bid", "Refresh Metadata", "Share", "Open original on IPFS", "Report"].map(item =>
                                                                    <div
                                                                        className="w-full py-1.5 cursor-pointer hover:bg-gray-200 hover:dark:bg-[#3c379d] px-3 text-left"
                                                                        key={item}
                                                                        onClick={() => hanldeThreeDotBtn(index)}>
                                                                        <h5 className="text-l-LightBlack dark:text-white text-base whitespace-nowrap font-semibold
                                                                    overflow-hidden overflow-ellipsis">{item}</h5>
                                                                    </div>
                                                                )}
                                                            </motion.div>
                                                        }
                                                    </AnimatePresence>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="h-[180px] xxsm:h-[224px] xsm:h-[180px] sm:h-[216px] md:h-[176px] relative mt-2 rounded-xl">
                                        <div className="w-full h-full rounded-lg overflow-hidden">
                                            <img src={data.thumb} alt="" className="w-full h-full object-cover hover:scale-125 transition-all" />
                                        </div>

                                        <div className="w-9/12 rounded-tr-xl bg-cusBlack absolute left-0 bottom-0 p-1 flex justify-start items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={16} height={15} viewBox="0 0 16 15">
                                                <defs>
                                                    <clipPath id="clip-path">
                                                        <rect id="Rectangle_814" data-name="Rectangle 814" width={16} height={15} transform="translate(0 0)" fill="#fb0" />
                                                    </clipPath>
                                                </defs>
                                                <g id="Group_1121" data-name="Group 1121" transform="translate(0 0)" clipPath="url(#clip-path)">
                                                    <path id="Path_662" data-name="Path 662" d="M113.614,342c-3.234,1.864-2.846,7.114-2.846,7.114a2.527,2.527,0,0,1-1.423-2.608,5.782,5.782,0,0,0-2.846,4.979,5.691,5.691,0,0,0,11.382,0c0-4.624-4.268-5.573-4.268-9.485Zm-.923,13.216a2.134,2.134,0,1,1-1.033-4.142c2.761-.688,3.107-2.242,3.107-2.242s1.377,5.523-2.075,6.383Z" transform="translate(-104.749 -341.967)" fill="#fb0" />
                                                </g>
                                            </svg>
                                            <UseTimeCountdown endDate={data.time} />
                                        </div>
                                    </div>

                                    <div className="mt-4 mb-2 flex justify-between items-center">
                                        <h4 className="text-sm text-cusBlack dark:text-white group-hover:text-white ">"{data.title}</h4>
                                        <svg className="w-[11px]" viewBox="0 0 256 417" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
                                            <path className="fill-[#343434] dark:fill-[#FFFFFF60]" fill="" d="M127.961 0l-2.795 9.5v275.668l2.795 2.79 127.962-75.638z" />
                                            <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 0L0 212.32l127.962 75.639V154.158z" />
                                            <path className="fill-[#3C3C3B] dark:fill-[#FFFFFF60]" fill="" d="M127.961 312.187l-1.575 1.92v98.199l1.575 4.6L256 236.587z" />
                                            <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 416.905v-104.72L0 236.585z" />
                                            <path className="fill-[#141414] dark:fill-[#FFFFFF20]" fill="" d="M127.961 287.958l127.96-75.637-127.96-58.162z" />
                                            <path className="fill-[#393939] dark:fill-[#FFFFFF60]" fill="" d="M0 212.32l127.96 75.638v-133.8z" />
                                        </svg>

                                    </div>


                                    <p className="text-cusBlack dark:text-cusBlueWhite group-hover:text-[#A4B1E2] text-xs text-left">{data.author}</p>

                                    <div className="flex justify-between items-center">
                                        <h4 className="text-xs font-semibold text-cusBlack dark:text-white group-hover:text-white">{data.price} ETH</h4>
                                        <p className="text-xs text-cusBlack dark:text-cusBlueWhite group-hover:text-[#A4B1E2] ">1/{data.aMA}</p>

                                        <button onClick={() => handleNFTOnClick(data.id)} className="font-semibold
                                    bg-cusBrightLink dark:bg-black text-sky-800 dark:text-cusLink text-xs px-2.5 py-1 rounded-full">
                                            {data.authorShow ? "Place a Bid" : "Buy Now"}
                                        </button>
                                    </div>
                                </div>
                            </SwiperSlide>
                        )}
                    </Swiper>
                </div>
            </div>


            {/* ----------------------------Hot Collection---------------------------- */}
            <div className="mt-14 swiper_pagination_controller_box relative">
                <div className="flex justify-between items-center">
                    <div className="relative inline-block">
                        <h1 className="xs:text-2xl xl:text-3xl mr-3 font-extrabold text-cusBlack dark:text-white">Hot Collections</h1>
                        <div className="bottom-1 absolute -right-4">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={12} height={12} viewBox="0 0 12 12">
                                <defs>
                                    <linearGradient id="linear-gradient" x1="0.875" y1="0.174" x2="0.139" y2="0.84" gradientUnits="objectBoundingBox">
                                        <stop offset={0} stopColor="#00dbff" />
                                        <stop offset="0.529" stopColor="#e315e8" />
                                        <stop offset={1} stopColor="#ffd817" />
                                    </linearGradient>
                                </defs>
                                <circle id="Ellipse_1" data-name="Ellipse 1" cx={6} cy={6} r={6} fill="url(#linear-gradient)" />
                            </svg>
                        </div>
                    </div>
                </div>

                <Swiper
                    slidesPerView={1}
                    spaceBetween={10}
                    pagination={{
                        clickable: true,
                    }}
                    breakpoints={{
                        0: { slidesPerView: 1, spaceBetween: 0, },
                        350: { slidesPerView: 2, spaceBetween: 5, },
                        440: { slidesPerView: 3, spaceBetween: 40, },
                        640: { slidesPerView: 3, spaceBetween: 40, },
                        769: { slidesPerView: 3, spaceBetween: 75, },
                        1024: { slidesPerView: 4, spaceBetween: 5, },
                        1280: { slidesPerView: 7, spaceBetween: 15, },
                        1536: { slidesPerView: 7, spaceBetween: 15, },
                    }}
                    effect="fade"
                    modules={[Pagination]}
                    className="mySwiper mt-5 overflow-hidden"
                >
                    {discoverNFTData.map((data, index) =>
                        <SwiperSlide key={data.id}>
                            <div className="xs:w-36 sm:w-44 xl:w-full">
                                <img src={data.thumImage} alt="" className="w-full" />
                            </div>
                            <div className="mt-4 flex justify-start items-center">
                                <div className="w-[45px] h-[45px] overflow-hidden rounded-full flex justify-center items-center">
                                    <img src={data.photo} alt="" className="w-full h-full" />
                                </div>
                                <div className="xs:ml-3 xl:ml-2 2xl:ml-3 text-left">
                                    <h4 className="xs:text-sm sm:text-base xl:text-xs 2xl:text-sm 3xl:text-base text-cusBlack dark:text-white">{data.name}</h4>
                                    <p className="text-sm text-cusBlack dark:text-cusBlueWhite">${data.price.toLocaleString()}</p>
                                </div>
                            </div>
                        </SwiperSlide>
                    )}
                </Swiper>
            </div>

        </div >
    );
}
